export default __webpack_public_path__ + "static/media/wall.41ca63a9.png";